import { Typography, Box } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';

const ExcelUploadSection = () => {
  return (
    <>
      <Typography variant="body1" paragraph>
        To import data in bulk using Excel Upload, follow these steps:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            Click on{' '}
            <CloudUploadIcon
              fontSize="small"
              sx={{ verticalAlign: 'middle', mx: 0.5 }}
            />{' '}
            <strong>Upload</strong> button.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <DownloadIcon
              fontSize="small"
              sx={{ verticalAlign: 'middle', mx: 0.5 }}
            />{' '}
            <strong>Download Template</strong> and fill in the details in the
            expected format.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Browse the completed Excel file.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click on <strong>Upload</strong>.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            The system will validate and insert your data.
          </Typography>
        </li>
      </ul>
    </>
  );
};

export default ExcelUploadSection;
